import { useEffect, useState } from "react";
import api from "../api/adminApi";
import AdminLayout from "./AdminLayout";

export default function ProfesoresAdmin() {
  const [profesores, setProfesores] = useState([]);
  const [loading, setLoading] = useState(true);

  const [editandoId, setEditandoId] = useState(null);

  // archivo real (File)
  const [fotoFile, setFotoFile] = useState(null);

  const [form, setForm] = useState({
    nombre: "",
    descripcion: "",
    especialidad: "",
  });

  /* =============================
     CARGAR PROFESORES
  ============================== */
  const loadProfesores = async () => {
    try {
      const { data } = await api.get("/profesores");
      setProfesores(data);
    } catch (error) {
      console.error("Error cargando profesores", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadProfesores();
  }, []);

  /* =============================
     HELPERS
  ============================== */
  const resetForm = () => {
    setForm({
      nombre: "",
      descripcion: "",
      especialidad: "",
    });
    setFotoFile(null);
    setEditandoId(null);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  /* =============================
     CRUD
  ============================== */
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("nombre", form.nombre);
    formData.append("descripcion", form.descripcion);
    formData.append("especialidad", form.especialidad);

    // solo si se eligió archivo
    if (fotoFile) formData.append("foto", fotoFile);

    try {
      if (editandoId) {
        await api.put(`/profesores/${editandoId}`, formData);
        alert("Profesor actualizado");
      } else {
        await api.post("/profesores", formData);
        alert("Profesor creado");
      }

      resetForm();
      setLoading(true);
      await loadProfesores();
    } catch (error) {
      console.error(error);
      alert("Error al guardar profesor");
    }
  };

  const editarProfesor = (p) => {
    setForm({
      nombre: p.nombre || "",
      descripcion: p.descripcion || "",
      especialidad: p.especialidad || "",
    });
    setEditandoId(p.id);
    setFotoFile(null); // no podemos precargar file
  };

  const eliminarProfesor = async (id) => {
    if (!window.confirm("¿Eliminar este profesor?")) return;

    try {
      await api.delete(`/profesores/${id}`);
      alert("Profesor eliminado");
      setLoading(true);
      await loadProfesores();
    } catch (error) {
      console.error(error);
      alert("No se puede eliminar (puede estar asignado a un curso)");
    }
  };

  /* =============================
     RENDER
  ============================== */
  return (
    <AdminLayout>
      <h1>Gestión de Profesores</h1>

      {/* FORMULARIO */}
      <form onSubmit={handleSubmit} className="admin-form">
        <h3>{editandoId ? "Editar profesor" : "Crear profesor"}</h3>

        <input
          name="nombre"
          placeholder="Nombre del profesor"
          value={form.nombre}
          onChange={handleChange}
          required
        />

        <input
          name="especialidad"
          placeholder="Especialidad (opcional)"
          value={form.especialidad}
          onChange={handleChange}
        />

        <textarea
          name="descripcion"
          placeholder="Descripción / Biografía"
          value={form.descripcion}
          onChange={handleChange}
          rows={4}
        />

        <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setFotoFile(e.target.files?.[0] || null)}
          />

          {fotoFile && (
            <img
              src={URL.createObjectURL(fotoFile)}
              alt="preview"
              style={{ width: 60, height: 60, borderRadius: "50%", objectFit: "cover" }}
            />
          )}
        </div>

        <div style={{ display: "flex", gap: 10 }}>
          <button type="submit">
            {editandoId ? "Actualizar profesor" : "Guardar profesor"}
          </button>

          {editandoId && (
            <button type="button" onClick={resetForm}>
              Cancelar
            </button>
          )}
        </div>
      </form>

      <hr />

      {/* LISTA */}
      {loading ? (
        <p>Cargando profesores...</p>
      ) : (
        <table className="admin-table">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Imagen</th>
              <th>Especialidad</th>
              <th>Biografía</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {profesores.length === 0 ? (
              <tr>
                <td colSpan="5">No hay profesores</td>
              </tr>
            ) : (
              profesores.map((p) => (
                <tr key={p.id}>
                  <td>{p.nombre}</td>
                  <td>
                    {p.foto ? (
                      <img
                      src={`https://centromillennials.com/uploads/${p.foto}`}
                        alt={p.nombre}
                        style={{ width: 60, height: 60, borderRadius: "50%", objectFit: "cover" }}
                      />
                    ) : (
                      "Sin foto"
                    )}
                  </td>
                  <td>{p.especialidad || "-"}</td>
                  <td>{p.descripcion || "-"}</td>
                  <td>
                    <button type="button" onClick={() => editarProfesor(p)}>
                      Editar
                    </button>{" "}
                    <button type="button" onClick={() => eliminarProfesor(p.id)}>
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </AdminLayout>
  );
}
